import React from 'react';
import logoutSuccess from '@/public/assets/logout-success.png';
import logoutSuccess2x from '@/public/assets/logout-success@2x.png';
import logoutSuccess3x from '@/public/assets/logout-success@3x.png';
import ExplainHeader from '~/component/login/H5/ExplainHeader';
import './index.less';

const LogoutSuccess = () => (
    <div className="h5-logout-success-wrapper">
        <ExplainHeader class="success-explain">单点登录系统</ExplainHeader>
        <div className="h5-logout-success-modal">
            <div className="h5-logout-success-content-wrapper">
                <img
                    srcSet={`${logoutSuccess},
                            ${logoutSuccess2x} 2x,
                            ${logoutSuccess3x} 3x,`}
                    src={logoutSuccess}
                    alt="logout-success"
                />
                <p className="img-explain">注销成功</p>
                <p>您已经成功退出CAS系统，谢谢使用！出于安全考虑，请关闭您的浏览器。</p>
            </div>
        </div>
    </div>
);

export default LogoutSuccess;
